module.exports = __webpack_public_path__ + "img/HelveticaNeueMedium.79d114e7.png";